module.exports = __webpack_public_path__ + "guide-service03.f990a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/guide-service03.svg
// module id = ./src/_asset/sources/assets/images/@svg/guide-service03.svg
// module chunks = main